export enum AppMessages {
  APP_MESSAGE_UNRESPONSIVE = 'app-message-unresponsive',
  APP_MESSAGE_UNRESPONSIVE_NO_ACTIVE_OUTBREAK = 'app-message-unresponsive-no-active-outbreak',
  APP_MESSAGE_UNRESPONSIVE_SELECTED_OUTBREAK_NOT_ACTIVE = 'app-message-unresponsive-selected-outbreak-no-active',
  APP_MESSAGE_UNRESPONSIVE_EDIT_COT = 'app-message-unresponsive-edit-cot',
  APP_MESSAGE_DUPLICATE_PERSONS = 'app-message-duplicate-persons',
  APP_MESSAGE_MUST_CHANGE_PASSWORD = 'app-message-must-change-password',
  APP_MESSAGE_USER_IN_MULTIPLE_TEAMS = 'app-message-user-in-multiple-teams',
  APP_MESSAGE_HISTORY_FOLLOW_UPS = 'app-message-history-follow-ups',
  APP_MESSAGE_DUPLICATE_MERGE_ACTIVE_OUTBREAK = 'app-message-duplicate-merge-active-outbreak',
  APP_MESSAGE_IMPORT_DATA_MAPPING_FINISHED = 'app-message-import-data-mapping-finished',
  APP_MESSAGE_IMPORT_DATA_SUCCESSFUL = 'app-message-import-data-successful',
  APP_MESSAGE_DATE_OF_REPORTING_SHOULD_NOT_BE_BEFORE_DATE_OF_ONSET = 'app-message-date-of-reporting-should-not-be-before-date-of-onset',
  APP_MESSAGE_LAST_CONTACT_SHOULD_NOT_BE_BEFORE_DATE_OF_ONSET = 'app-message-last-contact-should-not-be-before-date-of-onset',
  APP_MESSAGE_HOSPITALIZATION_START_DATE_SHOULD_NOT_BE_BEFORE_DATE_OF_ONSET = 'app-message-hospitalization-should-not-be-before-date-of-onset',
  APP_MESSAGE_DUPLICATE_ENTITY_MASK = 'app-message-duplicate-entity-mask',
  APP_MESSAGE_PASTE_WARNING = 'app-message-paste-warning',
  APP_MESSAGE_CONVERT_RELATIONSHIP_WARNING = 'app-message-convert-relationship-warning',
  APP_MESSAGE_IMPORT_USER_DATA_WARNING = 'app-message-import-user-data-warning',
  APP_MESSAGE_IMPORT_TEAM_DATA_WARNING = 'app-message-import-team-data-warning'
}
